module.exports = __webpack_public_path__ + "img/Pista_0220.6ff1f898.png";